var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board__badges px-3 pb-4"},[_c('v-chip',{attrs:{"color":_vm.color(_vm.badgeColor),"small":"","dark":""}},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }